// Design System
// Typography

export const fonts = {
  regular: 'Inter-Regular',
  medium: 'Inter-Medium',
  semibold: 'Inter-Semibold',
  bold: 'Inter-Bold',
};
